const pagesIndividualHomeEn = {
  application: {
    categories: {
      contractorCore: 'Contractor Core',
      gaOperationCore: 'GA Operation Core',
      itOperationCore: 'IT Operation Core',
      laborCore: 'Labor Core'
    },
    emptyState: {
      description: 'Currently, there are no requests or notifications available. If new ones become available, they will be displayed in this section.',
      title: 'No requests or notifications available'
    },
    title: 'Request'
  },
  applicationOperationPackages: {
    cores: {
      contractorCore: 'Contractor Core',
      gaOperationCore: 'GA Operation Core',
      itOperationCore: 'IT Operation Core',
      laborCore: 'Labor Core'
    },
    title: 'Submit'
  },
  approvalTray: {
    empty: 'No approval tasks',
    emptyState: {
      allCompleted: 'All approvals completed',
      description: 'Currently, there are no tasks that require approval. If a new approval task arises, it will be displayed here.'
    },
    status: {
      waitingApproval: 'Waiting for approval'
    },
    tableHeaders: {
      applicant: 'Applicant',
      approvalFlow: 'Approval Flow',
      approvalTask: 'Approval Task',
      deadline: 'Deadline'
    },
    title: 'Approval Tray'
  },
  chat: {
    agent: 'Agent',
    placeholder: 'Get your business operation done'
  },
  clocking: {
    breakEnd: 'End break',
    breakEnded: 'Break ended',
    breakStart: 'Start break',
    breakStarted: 'On break',
    clockIn: 'Clock in',
    clockInPending: 'Before clock-in',
    clockOut: 'Clock out',
    clockedIn: 'Clocked in',
    clockedOut: 'Clocked out',
    editRequest: 'Edit request',
    leaveRequest: 'Leave request',
    menuAriaLabel: 'Open actions',
    missedPunch: 'Missed punch',
    requestCorrection: 'Request correction',
    storeSelectorAriaLabel: 'Select store',
    title: 'Attendance Book'
  },
  greeting: {
    afternoon: 'Good afternoon',
    evening: 'Good evening',
    morning: 'Good morning'
  },
  inquiry: {
    title: 'Inquiry & Reference'
  },
  lookup: {
    clockingCard: {
      empty: 'No attendance summary available yet.',
      overtime: 'Overtime',
      paidLeave: 'Paid leave',
      paidLeaveRemaining: 'Remaining',
      paidLeaveUsed: 'Used',
      title: 'Attendance Book',
      viewDetail: 'View details',
      workHoursTrend: 'Working hours trend',
      workingHours: 'Working hours'
    },
    deviceCard: {
      empty: 'No devices assigned.',
      title: 'Devices',
      viewDetail: 'View details'
    },
    equipmentCard: {
      empty: 'No equipment assigned.',
      title: 'Equipment',
      viewDetail: 'View details'
    },
    paySlipCard: {
      empty: 'No pay slip available yet.',
      netLabel: 'Net pay',
      scheduledLabel: 'Scheduled',
      title: 'Pay slip',
      viewDetail: 'View details'
    },
    scheduleCard: {
      empty: 'No shift schedule available yet.',
      nextShift: 'Next shift',
      noShift: 'No upcoming shift',
      scheduledDays: 'Scheduled days this month',
      title: 'Work Schedule',
      viewDetail: 'View details'
    },
    softwareCard: {
      empty: 'No software assigned.',
      title: 'Software',
      viewDetail: 'View details'
    },
    title: 'Inquiry & Reference',
    units: {
      day: 'days'
    }
  },
  myRequests: {
    empty: 'No requests',
    status: {
      approved: 'Approved',
      pending: 'Pending',
      rejected: 'Rejected'
    },
    tableHeaders: {
      progress: 'Progress',
      requestDate: 'Request Date',
      requestType: 'Request Type',
      status: 'Status'
    },
    title: 'My Requests'
  },
  myTasks: {
    empty: 'No tasks assigned',
    tableHeaders: {
      dueDate: 'Due date',
      progress: 'Progress',
      task: 'Task'
    },
    title: 'My Tasks'
  },
  name: '{{name}}',
  nav: {
    clockingRecord: 'Attendance book',
    descriptive: {
      approvalTray: 'Approval Tray',
      attendance: 'Attendance',
      contract: 'Contract',
      devices: 'Devices',
      hr: 'HR',
      it: 'IT',
      labor: 'Labor',
      myRequests: 'My Requests',
      software: 'Software',
      tasks: 'Tasks'
    },
    lookup: 'Inquiry & Reference',
    menu: 'Menu',
    myTasks: 'My Tasks',
    paySlip: 'Pay Slip',
    requests: 'Request',
    workSchedule: 'Work Schedule'
  },
  nextTask: 'Next Task',
  operationPackages: {
    emptyState: {
      allCompleted: 'All completed',
      description: 'Currently, there are no procedures that require attention. If a new procedure arises, it will be displayed on this page.'
    }
  },
  taskStatuses: {
    ongoing: 'Ongoing'
  },
  viewAll: 'View all',
  welcome: 'Welcome'
};
export default pagesIndividualHomeEn;